import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_UNIDAD, ROW_COUNT, API_ADMIN_GERENCIA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import IVicePresidencia from "../../../entities/IVicePresidencia";
import AdminLista from "../AdminLista";
import IUnidad from "../../../entities/IUnidad";
import { cParamsActiveOrderTitle, cParamsPageSize } from "../../../helpers/paramsHelper";
interface IGerenciaProps {
  cbVicePresidencia?: Array<IVicePresidencia>;
  items?: Array<any>;
}
const Gerencia = ({ cbVicePresidencia, items }: IGerenciaProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboGrc, setComboGrc] = useState<Array<IVicePresidencia>>(cbVicePresidencia || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = cParamsPageSize(pageSize);
    let result =
      items !== undefined
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, params)).result;

    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result
      .data;
    setComboGrc(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = (filter: Partial<IUnidad>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }

    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IUnidad, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
              CORRELATIVO_ACTUAL: "",
              CORRELATIVO_RECLAMOS: "",
              CORRELATIVO_SIGUIENTE: "",
              ES_USUARIO_BACKUP: true,
              ID_GERENCIA_SUBGERENCIA: "1",
              NOMBRE_GERENCIA_SUBGERENCIA: "",
              NOMBRE_PROYECTO: "",
              USUARIO_BACKUP: "",
              USUARIO_BACKUP_DISPLAY: "",
              USUARIO_RESPONSABLE: "",
              USUARIO_RESPONSABLE_DISPLAY: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_GERENCIA_SUBGERENCIA",
            value: comboGrc.map((grc) => {
              return { text: grc.TITULO, value: grc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"Unidad"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Unidad"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Gerencia;
